import { defineMessages } from "react-intl";

const messages = defineMessages({
    newSystem: {
        id: "tasks.barSorting.newSystem",
    },
});

export default messages;
